// ─── CODA-VAULT DESIGN SYSTEM — CREAM PIXEL ──────────────────────────────────
export const DESIGN_SYSTEM = {

  font: {
    display: "'GeistPixel', 'Space Grotesk', monospace",
    body:    "'Roboto', 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif",
    mono:    "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
  },

  fontWeight: {
    light:    300,
    normal:   400,
    medium:   500,
    semibold: 600,
    bold:     700,
    extrabold:800,
  },

  fontSize: {
    xs:      12,
    sm:      13,
    md:      14,
    lg:      16,
    xl:      20,
    xxl:     28,
    display: 40,
    hero:    56,
  },

  radius: {
    sm:   '6px',
    md:   '10px',
    lg:   '12px',
    xl:   '16px',
    full: '9999px',
  },

  spacing: {
    xs:  '6px',
    sm:  '8px',
    md:  '12px',
    lg:  '20px',
    xl:  '32px',
    xxl: '48px',
  },

  shadow: {
    sm:    '2px 2px 0 #2a2118',
    md:    '3px 3px 0 #2a2118',
    lg:    '4px 4px 0 #2a2118',
    xl:    '5px 5px 0 #2a2118',
    hover: '1px 1px 0 #2a2118',
    gold:  '3px 3px 0 #2a2118',
    card:  '3px 3px 0 #2a2118',
  },

  colors: {
    nav: {
      bg:           '#2a2118',              // dark sidebar background
      border:       'rgba(255,255,255,0.1)',// subtle dividers
      text:         '#ffffff',              // logo / primary text
      textMuted:    'rgba(255,255,255,0.72)', // inactive nav items
      textTertiary: 'rgba(255,255,255,0.4)', // very muted (feedback, collapse btn)
      hoverBg:      'rgba(255,255,255,0.07)', // nav item hover
      activeBg:     'rgba(240,191,107,0.12)', // active item tint
      activeText:   '#f0bf6b',             // gold for active nav item
      searchBg:     'rgba(255,255,255,0.06)',
      kbdBg:        'rgba(255,255,255,0.1)',
    },
    bg: {
      primary:   '#faedd6',   // cream — page bg
      secondary: '#f5f0e4',   // cream2 — sidebar bg
      card:      '#ffffff',   // white card surfaces
      hover:     '#f0ebe0',   // card hover
      elevated:  '#f5f0e4',   // inputs, dropdowns
      surface:   '#ece7dc',   // active / selected state
    },
    border: {
      light:  '#2a2118',      // hard dark border
      medium: '#2a2118',      // same (was opacity variant)
      accent: '#f0bf6b',      // gold accent border
    },
    text: {
      primary:   '#2a2118',              // dark brown-black
      secondary: '#55381f',              // brown
      tertiary:  '#7a6550',              // muted brown
      muted:     '#a08870',              // very muted
      gold:      '#f0bf6b',              // gold
      label:     'rgba(42,33,24,0.45)', // uppercase section labels
    },
    brand: {
      primary:   '#f0bf6b',   // gold
      light:     '#f5ce87',   // light gold
      dark:      '#d4a043',   // deep gold
      accent:    '#1562c8',   // blue
      secondary: '#f5ce87',   // light gold alias
      muted:     'rgba(240,191,107,0.15)',
      blue:      '#1562c8',   // blue
      purple:    '#7c3aed',   // kept for badges/accents
    },
    gradient: {
      main:   'linear-gradient(135deg, #f0bf6b 0%, #e8a832 100%)',
      subtle: 'linear-gradient(135deg, rgba(240,191,107,0.12) 0%, rgba(232,168,50,0.06) 100%)',
      hover:  'linear-gradient(135deg, rgba(240,191,107,0.18) 0%, rgba(232,168,50,0.10) 100%)',
      hero:   'linear-gradient(135deg, #f5f0e4 0%, #fdf8f0 100%)',
      card:   'linear-gradient(145deg, #ffffff 0%, #f5f0e4 100%)',
      gold:   'linear-gradient(135deg, #d4a043 0%, #f0bf6b 40%, #f5ce87 100%)',
    },
    accent: {
      gold:   '#f0bf6b',
      amber:  '#f0bf6b',
      purple: '#7c3aed',
      pink:   '#ec4899',
      red:    '#c0392b',
      green:  '#16a34a',
      blue:   '#1562c8',
    },
  },

  transition: {
    fast:   '100ms ease',
    normal: '150ms ease',
    slow:   '250ms ease',
  },
};
